export const INBOX_PANEL_ID = "inbox-notes";
